import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IEventItem } from '@core/interfaces/ievent-item';
import { EventItemService } from '@core/services/event-item.service';
import { Subscription, take } from 'rxjs';
import { ImageModalComponent } from '../shared/image-modal/image-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScreenService } from '@core/services/screen.service';
import { HostListener } from '@angular/core';
import { ScreenSize } from '@core/enums/screen-service';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarouselComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateEventGroups();
  }
  private subscriptions = new Subscription();
  events: IEventItem[] = [];
  eventGroups: IEventItem[][] = [];
  defaultGroupSize = 3;
  defaultGroupSizeMobile = 1;

  constructor(
    private eventItem: EventItemService,
    private screenService: ScreenService,
    private modal: NgbModal) { }

  ngOnInit(): void {
    this.getEventItem();
    this.updateEventGroups();
  }

  getEventItem(): void {
    this.subscriptions.add(
      this.eventItem
        .getAll()
        .pipe(take(1))
        .subscribe((res: any) => {
          this.events = res;
          this.updateEventGroups();
        })
    );
  }

  // Cache the grouped events in a field so the template iterates a stable
  // array reference. Calling getEventGroups() directly in the @for produced
  // a new array every change-detection cycle (NG0100 under Angular 21).
  private updateEventGroups(): void {
    this.eventGroups = this.getEventGroups();
  }

  isSmallScreen(): boolean {
    return this.screenService.getScreenSize() === ScreenSize.Small;
  }

  openImageModal(imageUrl: string): void {
    const modalRef = this.modal.open(ImageModalComponent, { size: 'lg' });
    modalRef.componentInstance.imageUrl = imageUrl;
    modalRef.componentInstance.title = this.events.find(
      event => event.imageUrl === imageUrl)?.title || 'Default Title';
  }

  splitIntoGroups(array: IEventItem[], groupSize: number = this.defaultGroupSize): IEventItem[][] {
    const result: IEventItem[][] = [];
    for (let i = 0; i < array.length; i += groupSize) {
      result.push(array.slice(i, i + groupSize));
    }
    return result;
  }

  splitIntoGroupsMobile(array: IEventItem[], groupSize: number = this.defaultGroupSizeMobile): IEventItem[][] {
    const result: IEventItem[][] = [];
    for (let i = 0; i < array.length; i += groupSize) {
      result.push(array.slice(i, i + groupSize));
    }
    return result;
  }

  getEventGroups(): IEventItem[][] {
    return this.isSmallScreen()
      ? this.splitIntoGroupsMobile(this.events, this.defaultGroupSizeMobile)
      : this.splitIntoGroups(this.events, this.defaultGroupSize);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
